import { CultureInfo } from '../culture-info.model';
import { CultureInfoFfLatn } from './ff-Latn';

/**
 * @ignore
 */
export const CultureInfoFfLatnGH: CultureInfo = {
  name: 'ff-Latn-GH',
  displayName: 'Pulaar (Latn, Ganaa)',
  iso3LanguageCode: 'ful',
  iso2LanguageCode: 'ff',
  ietfLanguageTag: 'ff-Latn-GH',
  parent: CultureInfoFfLatn
};
